"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;

function show(title, transcriptData, relativeToElement) {
  var WL = window.screenLeft || window.screenX || 0;
  var WT = window.screenTop || window.screenY || 0;
  var RR = $(relativeToElement);
  var BL = RR.offset().left + RR.width();
  var BT = RR.offset().top - $(window).scrollTop();
  var props = {
    width: 400,
    height: 600,
    top: Math.round(WT + BT),
    left: Math.round(WL + BL + 20),
    menubar: 0,
    toolbar: 0,
    location: 0,
    personalbar: 'no',
    directories: 'no',
    scrollbars: true,
    resizable: true,
    dependent: true
  };

  if ('availWidth' in screen) {
    var lMin = screen.availLeft || 0,
        lMax = lMin + screen.availWidth;

    if (props.width + props.left > lMax - 20) {
      props.left = lMax - (20 + props.width);
    }
  }

  if ('availHeight' in screen) {
    var hMin = screen.availTop || 0,
        hMax = hMin + screen.availHeight;

    if (props.height + props.top > hMax - 80) {
      props.top = hMax - (80 + props.height);
    }
  }

  var pl = Object.keys(props).map(function (prop) {
    return props[prop] === true ? prop : "".concat(prop, "=").concat(props[prop]);
  }).join(',');
  var W = window.open('about:blank', '_blank', pl);
  W.focus();
  W.document.open('text/html');
  W.document.write("\n\t\t<html>\n\t\t\t<head>\n\t\t\t\t<meta charset='utf-8'>\n\t\t\t\t<meta http-equiv='X-UA-Compatible' content='IE=edge'>\n\t\t\t\t<title>Video Transcript</title>\n\t\t\t\t<base href='".concat(document.querySelector('base').href, "'>\n\t\t\t\t").concat([].map.call(document.querySelectorAll('link, style'), function (rule) {
    return rule.outerHTML;
  }).join(''), "\n\t\t\t\t").concat([].map.call(document.querySelectorAll('head script:not([async])'), function (rule) {
    return rule.outerHTML;
  }).join(''), "\n\t\t\t</head>\n\t\t\t<body class='SiteLayout VideoTranscript loaded'>\n\t\t\t\t<div id='outerContainer'>\n\t\t\t\t\t<div class='page-main' id='mainContentContainer'>\n\t\t\t\t\t\t<div id='transcript'>\n\t\t\t\t\t\t\t<div id='videoTitle'>\n\t\t\t\t\t\t\t\t").concat(title.replace(/&/g, '&amp;').replace(/</g, '&lt;'), "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div id='videoBody'>\n\t\t\t\t\t\t\t\t").concat(transcriptData, "\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<script>\n\t\t\t\t\t$(window).trigger('finish-page-script');\n\t\t\t\t</script>\n\t\t\t</body>\n\t\t</html>\n\t"));
  W.document.close();
}